import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface GuidelineItem {
    labelKey: string;
    textKey: string;
}

@Component({
    selector: 'lokos-guidelines-dialog',
    templateUrl: './guidelines-dialog.component.html',
    styleUrl: './guidelines-dialog.component.scss',
    standalone: false,
})
export class GuidelinesDialogComponent {
    constructor(public dialogRef: MatDialogRef<GuidelinesDialogComponent>) {}

    guidelines: GuidelineItem[] = [
        { labelKey: 'basicDetails', textKey: 'guidelineBasicDetails' },
        { labelKey: 'governance', textKey: 'guidelineGovernance' },
        { labelKey: 'clfOperations', textKey: 'guidelineClfOperations' },
        { labelKey: 'clfCompliance', textKey: 'guidelineClfCompliance' },
        { labelKey: 'cmtcProfile', textKey: 'guidelineCmtcProfile' },
        { labelKey: 'resourcesPerson', textKey: 'guidelineResourcesPerson' },
    ];

    onClose() {
        this.dialogRef.close();
    }
}
